"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _translate = _interopRequireDefault(require("../translate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var cookieLeft = 'SBV/resolve/left-side',
    cookieRight = 'SBV/resolve/right-side';

var ClipboardButton = /*#__PURE__*/function (_React$Component) {
  _inherits(ClipboardButton, _React$Component);

  function ClipboardButton(props) {
    var _this;

    _classCallCheck(this, ClipboardButton);

    _this = _possibleConstructorReturn(this, (ClipboardButton.__proto__ || Object.getPrototypeOf(ClipboardButton)).call(this, props));
    _this.addToClipboard = _this.addToClipboard.bind(_assertThisInitialized(_this));
    _this.checkState = _this.checkState.bind(_assertThisInitialized(_this));
    _this.state = {
      disabled: false
    };
    return _this;
  }

  _createClass(ClipboardButton, [{
    key: "checkState",
    value: function checkState(userId) {
      if (_jsCookie.default.get(cookieLeft) !== undefined && _jsCookie.default.get(cookieRight) !== undefined) {
        // Both slots for resolve duplicates are full
        this.setState({
          disabled: true
        });
      } else {
        if (_jsCookie.default.get(cookieLeft) === userId || _jsCookie.default.get(cookieRight) === userId) {
          // userId is already in clipboard
          this.setState({
            disabled: true
          });
        }
      }
    }
  }, {
    key: "addToClipboard",
    value: function addToClipboard() {
      var left = _jsCookie.default.get(cookieLeft);

      if (left === undefined) {
        _jsCookie.default.set(cookieLeft, this.props.userId);
      } else {
        _jsCookie.default.set(cookieRight, this.props.userId);
      }

      this.setState({
        disabled: true
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      //eslint-disable-line camelcase
      if (this.props.userId !== nextProps.userId) {
        this.checkState(nextProps.userId);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.checkState(this.props.userId);
    }
  }, {
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
        disabled: this.state.disabled || this.props.userId === '' || this.props.userId === -1 || !this.props.userId,
        className: "btn btn--icon",
        onClick: this.addToClipboard,
        title: t('add to clipboard')
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-copy"
      })));
    }
  }]);

  return ClipboardButton;
}(_react.default.Component);

ClipboardButton.propTypes = {
  userId: _propTypes.default.any.isRequired,
  t: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(ClipboardButton);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/clipboard-button/index.js
// module id = 263
// module chunks = 0